// client/src/services/socket.js
// Simple Socket.IO client singleton
let socket = null;

export async function getSocket() {
  if (socket) return socket;
  try {
    // Lazy import to avoid bundling issues if not used elsewhere
    const mod = await import('socket.io-client');
    const io = mod?.io || mod?.default?.io || mod?.default || null;
    if (!io) return null;
    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
    socket = io(baseUrl, {
      transports: ['websocket', 'polling'],
      withCredentials: true,
    });
    return socket;
  } catch (_e) {
    // Dependency may be missing in some builds; fail soft
    return null;
  }
}

export async function registerCurrentUser(userId) {
  try {
    const s = await getSocket();
    if (s && userId) s.emit('register', userId);
  } catch (_) {}
}

export async function onEvent(event, handler) {
  const s = await getSocket();
  if (!s) return () => {};
  s.on(event, handler);
  return () => s.off(event, handler);
}

export async function disconnectSocket() {
  try {
    if (socket) {
      socket.disconnect();
      socket = null;
    }
  } catch (_) {}
}
